import Button from 'components/Button';
import type { CreateCustomizationRequest } from 'models/api';
import { is } from 'utils/helpers';

import type { ExistingPlacement } from '../hooks';

import PrintPlacement from './PrintPlacement';

interface ExistingPrintPlacementsViewProps {
	addNewPrintPlacementButtonText: string | undefined;
	description: string | undefined;
	onCreateNewPrintPlacementClick: () => void;
	onSelectExistingPrintPlacementClick: (
		newPrint: CreateCustomizationRequest,
	) => void;
	printPlacements: ExistingPlacement[] | undefined;
	printPlacementsLabel: string | undefined;
	selectExistingPrintPlacementButtonText: string | undefined;
}

export default function ExistingPrintPlacementsView({
	addNewPrintPlacementButtonText,
	description,
	onCreateNewPrintPlacementClick,
	onSelectExistingPrintPlacementClick,
	printPlacements,
	printPlacementsLabel,
	selectExistingPrintPlacementButtonText,
}: ExistingPrintPlacementsViewProps) {
	return (
		<>
			<p className="font-bold">{printPlacementsLabel}</p>
			<p>{description}</p>
			{is.arrayWithLength(printPlacements) && (
				<ul
					className="mt-6 flex flex-col gap-2"
					data-cy="print-existing-placements"
				>
					{printPlacements.map((placement) => (
						<PrintPlacement
							key={`${placement.customizationId}-${placement.id}`}
							placement={placement.title || ''}
							logotypeName={placement.printImageFilename?.originalFileName}
							size={placement.option?.text}
							price={placement.option?.price?.priceIncVat}
							onClick={() => {
								onSelectExistingPrintPlacementClick({
									placementId: placement.id,
									printImageFilename: placement.printImageFilename?.fileName,
									optionKey: placement.option?.key,
								});
							}}
							buttonText={selectExistingPrintPlacementButtonText}
						/>
					))}
				</ul>
			)}
			<Button
				onClick={onCreateNewPrintPlacementClick}
				variant="cta"
				displayWidth="full"
				className="mt-6"
			>
				{addNewPrintPlacementButtonText}
			</Button>
		</>
	);
}
ExistingPrintPlacementsView.displayName =
	'ProductPrintPopover_ExistingPrintPlacementsView';
